export const apiConstants = {
  AppServiceInfo: 'AppServiceInfo/AppService',
};
